import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '@drone-js/core';
import 'component/common/ContentArea/ContentArea.scss';

interface ContentAreaProps extends BoxProps {
    max?: number;
}

export const ActivitiesContentAreaWidth = 744;

const ContentAreaContainer: React.FC<ContentAreaProps> = styled(Box)<ContentAreaProps>`
    && {
        max-width: ${(props) => ActivitiesContentAreaWidth * ((props.max || 100) / 100)}px;
    }
`;

const ContentArea: React.FC<React.PropsWithChildren<ContentAreaProps>> = (props) => {
    return <ContentAreaContainer {...props}>{props.children}</ContentAreaContainer>;
};
ContentArea.displayName = 'ContentArea';

export default ContentArea;
